module.exports = __webpack_public_path__ + "static/media/elham.ad2efd8d.png";